import './App.scss';
import { Route, Routes } from 'react-router-dom'
import Analytics from './components/Analytics'
import Layout from './components/Layout';
import Home from './components/Home';
import Services from './components/Services';
import Contact from './components/Contact';
import Portfolio from './components/Portfolio';
import PortfolioDetails from './components/Portfolio/PortfolioDetails';
import MyAdvisorDetail from './components/Portfolio/MyAdvisorDetail';
import ReaddyDetail from './components/Portfolio/ReaddyDetail';
import Pricing from './components/Pricing';
import WebPortfolio from './components/WebPortfolio';
import ScrollToTop from './components/ScrollToTop';
import NotFound from './components/NotFound';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Checkout from './components/Checkout';
import PaymentSuccess from './components/PaymentSuccess';

function App() {
  return (
    <>
      <Analytics />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="portfolio/web" element={<WebPortfolio />} />
          <Route path="portfolio/my-advisor" element={<MyAdvisorDetail />} />
          <Route path="portfolio/readdy-app" element={<ReaddyDetail />} />
          <Route path="portfolio/:slug" element={<PortfolioDetails />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="payment-success" element={<PaymentSuccess />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  )
}

export default App;
